<template>
  <div style="width: 100%;">

    <div class="data_box">
      <div class="pandect">
        <div class="home_data_box">
          <div class="home_data_statistics">
            <div>
              <p class="data_main">{{homeData.buildingCount || 0}}</p>
              <p class="data_title">总楼数</p>
            </div>
            <div>
              <p class="data_main">{{homeData.totalArea || 0}} <span class="data_title">m²</span></p>
              <p class="data_title">总面积</p>
            </div>
            <div>
              <p class="data_main">{{homeData.leasedArea || 0}} <span class="data_title">m²</span></p>
              <p class="data_title">已租面积: {{homeData.leasedAreaPercent}}</p>
            </div>
            <div>
              <p class="data_main">{{homeData.unleasedArea || 0}} <span class="data_title">m²</span></p>
              <p class="data_title">未租面积: {{homeData.unleasedAreaPercent}}</p>
            </div>
            <div>
              <p class="data_main">{{homeData.rentRate || 0}}</p>
              <p class="data_title">满租率:</p>
            </div>
            <div>
              <p class="data_main">{{homeData.enterpriseCount || '0'}}</p>
              <p class="data_title">入驻住户数量</p>
            </div>
            <div>
              <p class="data_main">{{homeData.predictYearRent || 0}} <span class="data_title">万元</span></p>
              <p class="data_title">年收入预计总额</p>
            </div>
            <div>
              <p class="data_main">{{homeData.oneYearRent || 0}} <span class="data_title">万元</span></p>
              <p class="data_title">年租金收入总额</p>
            </div>
          </div>
        </div>
      </div>
      <div class="all-table-class">
        <el-table
          :data="tableData"
          height="241"
          @row-click="buildingRowClick"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="楼栋名称">
          </el-table-column>
          <el-table-column
            prop="totalArea"
            label="总面积(m²)">
          </el-table-column>
          <el-table-column
            prop="rentArea"
            label="已租面积(m²)">
          </el-table-column>
          <el-table-column
            prop="unRentArea"
            label="未租面积(m²)">
          </el-table-column>
          <el-table-column
            prop="rentAreaPercent"
            label="已租比例">
          </el-table-column>
          <!--<el-table-column-->
          <!--prop="avgPrice"-->
          <!--label="在租均价">-->
          <!--</el-table-column>-->
          <el-table-column
            prop="enterpriseCount"
            label="入驻住户总数">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <h3 class="main_title">账单提醒</h3>
    <div style="display: flex;justify-content: space-between">
      <div id="dueInItems" style="width:49%; height:300px" class="box-line"></div>
      <div id="contract_follow" style="width:49%; height:300px" class="box-line"></div>
    </div>

    <div style="display: flex;justify-content: space-between; margin-top: 20px">
      <div style="width:49%; height:300px" class="box-line">
        <div style="display: flex;justify-content: space-between">
          <div>逾期未结算客户 ({{dueOverTotal}}家)</div>
          <el-pagination
            @current-change="dueOverCurrentChange"
            :page-size="dueOverPageSize"
            layout="prev, pager, next"
            :total="dueOverTotal">
          </el-pagination>
        </div>

        <div class="workbench-table-class">
          <el-table
            :data="dueOverTableData"
            style="width: 100%">
            <el-table-column
              prop="date"
              label="承租主体"
              width="200">
              <template slot-scope="scope">
                <span :title="scope.row.leaseName">{{scope.row.leaseName}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="金额总计(元)">
              <template slot-scope="scope">
                <span :title="scope.row.totalMoney">{{scope.row.totalMoney}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="逾期天数(天)">
              <template slot-scope="scope">
                <span :title="scope.row.overdueDay">{{scope.row.overdueDay}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="box-line" style="width:49%; height:300px">
        <div style="display: flex;justify-content: space-between">
          <div>账单跟进情况 ({{fellowBillTotal}})</div>
          <el-pagination
            @current-change="fellowBillCurrentChange"
            :page-size="fellowBillPageSize"
            layout="prev, pager, next"
            :total="fellowBillTotal">
          </el-pagination>
        </div>
        <div class="workbench-table-class">
          <el-table
            :data="fellowBillList"
            style="width: 100%">
            <el-table-column
              prop="date"
              label="跟进人"
              width="200">
              <template slot-scope="scope">
                <span :title="scope.row.fellowPeopleName">{{scope.row.fellowPeopleName}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="30天内可收(元/笔)">
              <template slot-scope="scope">
                <span :title="scope.row.recoverMoney">{{scope.row.recoverMoney || 0}}元 / {{scope.row.recoverCount || 0}}笔</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="逾期账单(元/笔)">
              <template slot-scope="scope">
                <span :title="scope.row.overdueMoney">{{scope.row.overdueMoney || 0}}元 / {{scope.row.overdueCount || 0}}笔</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <h3 class="main_title" style="margin-top: 40px;">资金流水</h3>
    <div style="position: relative">
      <div style="width: 120px;position: absolute; top: 10px; left: 0; right: 0; margin: 0 auto;z-index: 1">
        <el-switch
          v-model="capitalValue"
          active-text="金额"
          inactive-text="笔数">
        </el-switch>
      </div>
      <div id="capital_flow" style="height:300px" class="box-line"></div>
    </div>


<!--    <h3 class="main_title" style="margin-top: 40px;">新增客户统计</h3>-->
<!--    <div style="position: relative">-->
<!--      <div id="new_customers" style="height:300px" class="box-line"></div>-->
<!--    </div>-->


    <h3 class="main_title">合同签订及退租统计</h3>
    <div style="display: flex;justify-content: space-between; margin-bottom: 40px;">
      <div id="contract" style="width:100%; height:300px" class="box-line"></div>
    </div>


        <div class="finance-over-view-line" style="height: 280px;margin: 60px 0 20px 0;padding: 10px;position: relative;border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);">
      <chart-time-select @getData="getRentRateStatistics" />
      <common-line style="z-index: 1000" lineId='rentAccessRecordLine' :height='"260px"' :lineTitle='rentAccessRecordTitle' :legendData="rentAccessRecordLegendData" :xAxis="rentAccessRecordXAxis" :yAxis='rentAccessRecordYAxis' :series='rentAccessRecordSeries' />
    </div>
  </div>
</template>

<script>
import { api } from "../../api/Workbench";
import { nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";
import CommonLine from "../../../components/Echarts/Line/commonLine";

export default {
  components: {
    ChartTimeSelect,
    CommonLine
  },
  name: "workbench",
  data() {
    return {
      homeData: "",
      tableData: [],

      pendingApprovalTotal: 0,
      accountCode: "",
      total: 1,
      capitalValue: true,
      pageSize: 6,

      // 逾期未结算客户相关字段
      dueOverTotal: 0,
      dueOverPageSize: 5,
      dueOverPageNum: 1,
      dueOverTableData: [],

      // 账单跟进相关字段
      fellowBillTotal: 0,
      fellowBillPageSize: 5,
      fellowBillPageNum: 1,
      fellowBillList: [],

      // 近30天资金流水统计
      fellowLegendData: [],
      fellowXData: [],
      moneyFellowList: [],
      countFellowList: [],

      colorList: [
        "#37A2DA",
        "#32C5E9",
        "#9FE6B8",
        "#FF9F7F",
        "#FB7293",
        "#E7BFF3"
      ],

      rentAccessRecordRadio: false,
      rentAccessRecordTitle: "满租率",
      rentAccessRecordLegendData: ["推送成功", "推送失败"],
      rentAccessRecordXAxis: {
        type: "category",
        name: "日期",
        data: []
      },
      rentAccessRecordYAxis: [
        {
          type: "value",
          name: "满租率(%)",
          splitLine: {
            show: false
          }
        }
      ],
      rentAccessRecordSeries: []
    };
  },
  created() {
    this.accountCode = bus.global.accountCode;
  },
  mounted() {
    this.getHomeData();
    this.getBuildingList();
    this.getPendingApprovalPage();
    // 30天内可收
    this.getDueInItems();
    // 合同跟进
    this.getContractListGroupByFellower();
    // 逾期未结算客户
    this.getDueOverItems();
    // 账单跟进
    this.getFellowBillList();
    // 资金流水
    this.getmoneyFellowList();
    // 新增客户统计
    // this.getIncreaseCustomStatistics();
    // 合同签订及退租统计
    this.getOverDateContractListDetail();
    //满租率统计
    // this.getRentRateStatistics();
  },
  methods: {
    getBuildingList() {
      this.$axios
        .post(api.getBuildingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map(v => {
              for (let i in v) {
                if (v[i] !== 0) {
                  if (!v[i]) {
                    v[i] = "--";
                  }
                }
              }
            });
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取楼栋数据失败"));
    },
    buildingRowClick(row) {
      window.sessionStorage.setItem(
        "housingManagementPageBuildingTabState",
        row.code
      );
      window.sessionStorage.setItem(
        "housingManagementPageHousingTabState",
        "housing_resources"
      );
      window.sessionStorage.setItem("navTop", "resource");
      this.$router.push({
        name: "housing-management"
      });
    },
    getHomeData() {
      this.$axios
        .post(api.getHomeData, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.homeData = res.data.data;
          }
        })
        .catch(errorHandler("查询信息失败"));
    },
    toWorkbenchApproval() {
      this.$router.push({
        name: "workbench-approval"
      });
    },
    // 待我审批
    getPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = "1";
      reqData.pageSize = "10";
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios
        .post(api.getPageByApproveAccountCode, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            this.pendingApprovalTotal = res.data.data.total;
          }
        })
        .catch(errorHandler("获取待我审批数据失败"));
    },
    // 30天内可收
    getDueInItems() {
      this.$axios
        .post(api.getDueInItems, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let dueInItemsData = res.data.data;
            let totalItems = dueInItemsData.totalItems;
            let totalMoney = dueInItemsData.totalMoney;
            let tableData = dueInItemsData.items;
            let tipData = [];
            let bodyData = [];
            tableData.map(v => {
              if (tipData.indexOf(v.itemType) === -1) {
                tipData.push(v.itemType);
                let obj = { value: v.itemMoney, name: v.itemType };
                bodyData.push(obj);
              }
            });
            this.drawDueInItems(totalItems, totalMoney, tipData, bodyData);
          }
        })
        .catch(errorHandler("获取30天内可收数据失败"));
    },
    drawDueInItems(totalItems, totalMoney, tipData, bodyData) {
      let subtext = `待收总金额：${totalMoney}元  待收总笔数：${totalItems}笔`;
      let dueInItems = this.$echarts.init(
        document.getElementById("dueInItems")
      );
      dueInItems.setOption({
        title: {
          text: "30天内可收",
          subtext: subtext,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: tipData
        },
        color: [
          "#37A2DA",
          "#32C5E9",
          "#9FE6B8",
          "#FF9F7F",
          "#FB7293",
          "#E7BFF3"
        ],
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: bodyData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    },

    // 合同跟进
    getContractListGroupByFellower() {
      this.$axios
        .post(api.getContractListGroupByFellower, {})
        .then(res => {
          if (res.data.retCode === 1) {
            // console.log(res.data.data);
            let data = res.data.data;
            let fellowerList = [];
            let data1 = [];
            let data2 = [];
            let data3 = [];
            let data4 = [];
            data.map(v => {
              fellowerList.push(v.fellowerName);
              if (v.zeroContractCount) {
                data1.push(v.zeroContractCount);
              } else {
                data1.push(0);
              }
              if (v.thirtyContractCount) {
                data2.push(v.thirtyContractCount);
              } else {
                data2.push(0);
              }
              if (v.nintyContractCount) {
                data3.push(v.nintyContractCount);
              } else {
                data3.push(0);
              }
              if (v.beyondNintyContractCount) {
                data4.push(v.beyondNintyContractCount);
              } else {
                data4.push(0);
              }
            });
            this.drawContractListGroupByFellower(
              fellowerList,
              data1,
              data2,
              data3,
              data4
            );
          }
        })
        .catch(errorHandler("获取合同跟进数据失败"));
    },
    drawContractListGroupByFellower(fellowerList, data1, data2, data3, data4) {
      let contract_follow = this.$echarts.init(
        document.getElementById("contract_follow")
      );
      contract_follow.setOption({
        title: {
          text: "合同跟进分布"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ["到期未处理", "30天内到期", "30-90天内到期", "90天以上"],
          right: 10
        },
        grid: {
          left: "2%",
          right: "50px",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          name: "跟进人",
          data: fellowerList
        },
        yAxis: {
          type: "value",
          name: "合同数量"
        },
        series: [
          {
            name: "到期未处理",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#FF5151"
              }
            },
            data: data1
          },
          {
            name: "30天内到期",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#FF8D1E"
              }
            },
            data: data2
          },
          {
            name: "30-90天内到期",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#A0D428"
              }
            },
            data: data3
          },
          {
            name: "90天以上",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "#00A0E6"
              }
            },
            data: data4
          }
        ]
      });
    },

    dueOverCurrentChange(val) {
      this.dueOverPageNum = val;
      this.getDueOverItems();
    },

    // 逾期未结算客户
    getDueOverItems() {
      this.$axios
        .post(api.getDueOverItems, {
          pageNum: this.dueOverPageNum,
          pageSize: this.dueOverPageSize
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.items;
            this.dueOverTableData = data.list;
            this.dueOverTotal = data.total;
          }
        })
        .catch(errorHandler("获取逾期未结算客户失败"));
    },

    fellowBillCurrentChange(val) {
      this.fellowBillPageNum = val;
      this.getFellowBillList();
    },

    // 账单跟进
    getFellowBillList() {
      this.$axios
        .post(api.getFellowBillList, {
          pageNum: this.fellowBillPageNum,
          pageSize: this.fellowBillPageSize
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.fellowBillList = data.list;
            this.fellowBillTotal = data.total;
            // console.log(res.data.data)
          }
        })
        .catch(errorHandler("获取账单跟进失败"));
    },

    // 近30天资金流水列表（区分租金，保证金，物业费，其他）
    getmoneyFellowList() {
      this.$axios
        .post(api.getmoneyFellowList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let legendData = [];
            let xData = [];
            let xData1 = [];
            let seriesData = [];
            let seriesData2 = [];
            data.map((v, i) => {
              let obj = {
                name: v.itemTypeName,
                type: "line",
                stack: "总量",
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                smooth: true,
                itemStyle: {
                  color: this.colorList[i]
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: this.colorList[i]
                    },
                    {
                      offset: 1,
                      color: "#ffe"
                    }
                  ])
                },
                data: []
              };

              let obj2 = {
                name: v.itemTypeName,
                type: "line",
                stack: "总量",
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                smooth: true,
                itemStyle: {
                  color: this.colorList[i]
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: this.colorList[i]
                    },
                    {
                      offset: 1,
                      color: "#ffe"
                    }
                  ])
                },
                data: []
              };

              legendData.push(v.itemTypeName);

              xData1 = [];
              v.details.map(v => {
                xData1.push(v.occurDay || 0);
                obj.data.push(v.payMoney || 0);
                obj2.data.push(v.payCount || 0);
              });
              if (xData1.length > xData.length) {
                xData = xData1;
              }
              seriesData.push(obj);
              seriesData2.push(obj2);
            });
            this.moneyFellowList = seriesData;
            this.countFellowList = seriesData2;
            this.fellowLegendData = legendData;
            this.fellowXData = xData;
            this.drawmoneyFellowList(legendData, xData, seriesData, "元");
          }
        })
        .catch(errorHandler("获取近30天资金流水列表失败"));
    },
    drawmoneyFellowList(legendData, xData, seriesData, yCompany) {
      let capital_flow = this.$echarts.init(
        document.getElementById("capital_flow")
      );
      capital_flow.setOption({
        title: {
          text: "近30天资金流水统计"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          data: legendData
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true
        },

        xAxis: {
          type: "category",
          name: "时间",
          boundaryGap: false,
          data: xData
        },
        yAxis: {
          type: "value",
          name: yCompany,
          splitLine: {
            show: false
          }
        },
        series: seriesData
      });
    },

    // 新增客户统计
    getIncreaseCustomStatistics() {
      this.$axios
        .post(api.getIncreaseCustomStatistics, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let xData = [];
            let yData = [];
            data.map(v => {
              xData.push(v.occurDay);
              yData.push(v.customCount);
            });
            this.drawIncreaseCustomStatistics(xData, yData);
          }
        })
        .catch(errorHandler("获取新增客户统计失败"));
    },
    drawIncreaseCustomStatistics(xData, yData) {
      let new_customers = this.$echarts.init(
        document.getElementById("new_customers")
      );
      new_customers.setOption({
        title: {
          text: "新增客户统计"
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "3%",
          containLabel: true
        },
        color: [
          "#37A2DA",
          "#32C5E9",
          "#9FE6B8",
          "#FF9F7F",
          "#FB7293",
          "#E7BFF3"
        ],
        xAxis: {
          type: "category",
          name: "时间",
          data: xData
        },
        yAxis: {
          type: "value",
          name: "客户数",
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: yData,
            type: "line",
            symbol: "circle",
            smooth: true,
            symbolSize: 5,
            sampling: "average",
            itemStyle: {
              color: "#37A2DA"
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#37A2DA"
                },
                {
                  offset: 1,
                  color: "#ffe"
                }
              ])
            }
          }
        ]
      });
    },

    // 合同签订及退租统计
    getOverDateContractListDetail() {
      let xData = [];
      let increaseList = [];
      let reduceList = [];
      this.$axios
        .post(api.getIncreaseContractStatistics, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let increaseData = res.data.data;
            increaseData.map(v => {
              xData.push(v.datetime);
              increaseList.push(v.totalCount);
            });

            this.$axios
              .post(api.getReduceContractStatistics, {})
              .then(reduceRes => {
                if (reduceRes.data.retCode === 1) {
                  let reduceData = reduceRes.data.data;
                  reduceData.map(v => {
                    reduceList.push(v.totalCount);
                  });
                  this.drawOverDateContractListDetail(
                    xData,
                    increaseList,
                    reduceList
                  );
                }
              })
              .catch(errorHandler("获取合同退租数据失败"));
          }
        })
        .catch(errorHandler("获取合同签订数据失败"));
    },
    drawOverDateContractListDetail(xData, increaseList, reduceList) {
      let contract = this.$echarts.init(document.getElementById("contract"));
      contract.setOption({
        title: {
          text: "合同签订及退租统计"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["签订", "退租"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        color: ["#37A2DA", "#EE4739"],
        xAxis: {
          type: "category",
          name: "时间",
          data: xData
        },
        yAxis: {
          type: "value",
          name: "合同数",
          boundaryGap: [0, 0.01]
        },
        series: [
          {
            name: "签订",
            type: "bar",
            label: {
              normal: {
                show: true
              }
            },
            data: increaseList
          },
          {
            name: "退租",
            type: "bar",
            label: {
              normal: {
                show: true
              }
            },
            data: reduceList
          }
        ]
      });
    },

    //满租率
    // getRentRateListDetail() {
    //   this.$axios
    //     .post(api.getRentRateStatistics, {
    //       timeType: "DAY",
    //       startTime: "2021-05-21",
    //       endTime: "2021-05-23",
    //     })
    //     .then((res) => {
    //       if (res.data.retCode === 1) {
    //         console.log(res.data.data);
    //         let data = res.data.data;
    //         let xData = [];
    //         let yData = [];
    //         data.map((v) => {
    //           xData.push(v.time);
    //           if (v.rentRate) {
    //             yData.push(v.rentRate);
    //           } else {
    //             yData.push(0);
    //           }
    //         });
    //         this.drawRentRateListDetail(xData, yData);
    //       }
    //     })
    //     .catch(errorHandler("失败"));
    // },
    // drawRentRateListDetail(xData, yData) {
    //   let rent_rate = this.$echarts.init(document.getElementById("rent_rate"));
    //   rent_rate.setOption({
    //     title: {
    //       text: "满租率",
    //     },
    //     tooltip: {
    //       trigger: "axis",
    //       axisPointer: {
    //         // 坐标轴指示器，坐标轴触发有效
    //         type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
    //       },
    //     },
    //     legend: {
    //       data: ["123"],
    //       right: 10,
    //     },
    //     grid: {
    //       left: "2%",
    //       right: "50px",
    //       bottom: "3%",
    //       containLabel: true,
    //     },
    //     xAxis: {
    //       type: "category",
    //       name: "时间",
    //       data: xData,
    //     },
    //     yAxis: {
    //       type: "value",
    //       name: "满租率",
    //     },
    //     series: [
    //       {
    //         name: "满租率",
    //         type: "bar",
    //         // stack: "总量",
    //         label: {
    //           normal: {
    //             show: true,
    //           },
    //         },
    //         data: yData,
    //       },
    //     ],
    //   });
    // },
    getRentRateStatistics(timeType, startTime, endTime) {
      this.$axios
        .post(`${api.getRentRateStatistics}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: timeType || "DAY"
        })
        .then(res => {
          console.log(res);
          let data = res.data.data;
          let xData = [];
          let seriesData = [];
          data.map(v => {
            v.rentRate = parseFloat(v.rentRate).toFixed(2);
            seriesData.push(v.rentRate);
            if (timeType === 1) {
              let dateArr = v.time.split("-");
              let showData = `${dateArr[1]}-${dateArr[2]}`;
              xData.push(showData);
            } else {
              xData.push(v.time);
            }
          });
          this.rentAccessRecordXAxis.data = xData;
          this.rentAccessRecordSeries = [
            {
              name: "",
              type: "bar",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              itemStyle: {
                color: "#00A0E6"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00A0E6"
                  },
                  {
                    offset: 1,
                    color: "#ffe"
                  }
                ])
              },
              data: seriesData
            }
          ];
        })
        .catch(errorHandler("获取数据失败"));
    }
  },
  watch: {
    capitalValue(val) {
      if (val) {
        this.drawmoneyFellowList(
          this.fellowLegendData,
          this.fellowXData,
          this.moneyFellowList,
          "元"
        );
      } else {
        this.drawmoneyFellowList(
          this.fellowLegendData,
          this.fellowXData,
          this.countFellowList,
          "笔"
        );
      }
    }
  }
};
</script>

<style scoped>
.main_title {
  text-align: left;
  font-size: 20px;
  color: #333;
  padding-top: 2px;
  padding-left: 10px;
  border-left: 5px solid #00a0e6;
  margin: 10px 0 20px;
  font-weight: 400;
}
.box-line {
  padding: 5px 10px;
  border: 1px solid #dddddd;
  border-radius: 10px;
}

#dueInItems,
#contract_follow,
#capital_flow {
  text-align: left;
}

.spaceBetweenBox {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.approvalBox {
  font-size: 18px;
  line-height: 70px;
  background-color: #0e9cfb;
  margin: 0 -20px;
  padding: 0 20px;
  color: #ffffff;
}

.toAllApprovalList:hover {
  cursor: pointer;
  color: #00a0e6;
}

.flexStartBox {
  display: flex;
  justify-content: flex-start;
}

.approvalBgBox {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 15px 10px 0 0;
  text-align: center;
  background-color: #ffffff;
  position: relative;
}
.approvalBgBox i {
  color: #ffffff;
  font-size: 24px;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.data_box {
  border-radius: 15px;
  border: 1px solid #dddddd;
  padding-bottom: 30px;
  margin: 20px 0;
}
.pandect {
  display: flex;
  justify-content: space-between;
  height: 110px;
  padding: 20px;
  /*margin-bottom: 20px;*/
}
.pandect p {
  line-height: 32px;
}
.pandect > div {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pandect .home_data_box {
  flex: 1;
  height: 80px;
  margin: 0 0 0 30px;
}
.pandect .home_data_statistics {
  display: flex;
  justify-content: space-between;
}
.home_data_statistics > div {
  width: 140px;
  border-right: 1px solid #dddddd;
}
.home_data_statistics > div:last-child {
  border-right: 0;
}
.data_main {
  font-weight: 700;
  font-size: 20px;
  color: #333333;
}
.data_title {
  font-weight: 400;
  color: #a6a6a6;
  font-size: 14px;
}
</style>

<style lang="less">
.flexStartBox {
  sup {
    top: 4px !important;
    right: 12px !important;
  }
}
.workbench-table-class {
  .el-table thead {
    color: #48576a;
  }
  .el-table::before {
    height: 0;
  }
  .el-table .el-table__header tr {
    background-color: #eff1f5;
    th {
      background-color: #eff1f5;
    }
  }
  .el-table .cell {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-button--text {
    color: #1362ff;
    font-size: 14px;
    :hover {
      color: #4583ff;
    }
  }
  .el-table td {
    padding: 8px 0;
  }
  tbody {
    overflow: scroll;
  }
  .el-pagination {
    margin-top: 15px;
  }
}

.all-table-class {
  .el-table thead {
    color: #48576a;
  }
  .el-table::before {
    height: 0;
  }
  .el-table .el-table__header tr {
    background-color: #eff1f5;
    th {
      background-color: #eff1f5;
    }
  }
  .el-table .cell {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .el-button--text {
    color: #1362ff;
    font-size: 14px;
    :hover {
      color: #4583ff;
    }
  }
  .el-table td {
    padding: 7px 0;
  }
  tbody {
    overflow: scroll;
  }
  .el-pagination {
    margin-top: 20px;
  }
  tbody {
    .el-table__row {
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/InvestmentOverview/InvestmentOverview.vue